/**
 * Converts AddToAny's WordPress share button into the site subscription trigger.
 */
(function () {
  'use strict';

  var selector = 'a.a2a_button_wordpress';

  function updateLink(link) {
    link.setAttribute('title', 'Subscribe');
    link.setAttribute('href', '#subscribe-open');
  }

  function updateLinks(container) {
    if (container.nodeType !== Node.ELEMENT_NODE && container.nodeType !== Node.DOCUMENT_NODE) {
      return;
    }

    if (container.matches && container.matches(selector)) {
      updateLink(container);
    }

    container.querySelectorAll(selector).forEach(updateLink);
  }

  function openSubscribePopup() {
    var trigger = document.createElement('a');
    var originalUrl = window.location.href;

    trigger.href = '#subscribe-open';
    trigger.hidden = true;
    trigger.setAttribute('aria-hidden', 'true');

    document.body.appendChild(trigger);
    trigger.click();
    trigger.remove();

    window.setTimeout(function () {
      window.history.replaceState(window.history.state, document.title, originalUrl);
    }, 0);
  }

  function handleWordPressButtonClick(event) {
    var button = event.target.closest && event.target.closest(selector);

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    openSubscribePopup();
  }

  function init() {
    updateLinks(document);

    // Capture the click before AddToAny can rewrite its button URL.
    document.addEventListener('click', handleWordPressButtonClick, true);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(updateLinks);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  init();
})();
